import {Component, ChangeDetectionStrategy, OnInit} from '@angular/core';
import {Observable} from 'rxjs';

import {AuthUtils} from '../../shared/authutils';
import {CookieUtils} from '../../shared/cookieutils';
import {SystemUtils} from '../../shared/systemutils';
import {SystemPaths} from '../../shared/system-paths';

import {AmericanFootballUtils} from '../../shared/usftbl-utils';
import {CommonModalsComponent} from '../../shared/common-modals.component';
import {ScheduleComponent} from '../schedule.component';
import {AmericanFootballScoreboardComponent} from './scoreboard-usftbl.component';

import {GetAccountByUsernameService} from '../../service/get-account-by-username.service';
import {GetLeagueByAbbrService} from '../../service/get-league-by-abbr.service';
import {GetSeasonsForLeagueService} from '../../service/get-seasons-for-league.service';
import {GetGameSummariesForSeasonService} from '../../service/get-game-summaries-for-season.service';
import {GetTeamSummariesForSeasonService} from '../../service/get-team-summaries-for-season.service';

declare var dateFormat, window;

@Component({
    selector: 'app-root',
    changeDetection: ChangeDetectionStrategy.Default,
	templateUrl: '../schedule.component.html',
	styleUrls: ['../schedule.component.css']
})
export class AmericanFootballScheduleComponent extends ScheduleComponent implements OnInit {
	private americanFootballUtils;

	constructor(authUtils: AuthUtils, cookieUtils: CookieUtils, systemUtils: SystemUtils, systemPaths: SystemPaths,
		        GetLeagueByAbbrService: GetLeagueByAbbrService,
			    GetSeasonsForLeagueService: GetSeasonsForLeagueService,
				GetGameSummariesForSeasonService: GetGameSummariesForSeasonService,
				GetTeamSummariesForSeasonService: GetTeamSummariesForSeasonService,
				americanFootballUtils: AmericanFootballUtils) {

		super(authUtils, cookieUtils, systemUtils, systemPaths,
    		  GetLeagueByAbbrService,
			  GetSeasonsForLeagueService,
			  GetGameSummariesForSeasonService,
			  GetTeamSummariesForSeasonService);

		this.americanFootballUtils = americanFootballUtils;
	}

	public ngOnInit() {
		super.ngOnInit();
	}

	protected getPeriodLabel(periodNum: number, includeOrdinal: boolean, seasonType: string) {
		return this.americanFootballUtils.getPeriodLabel(periodNum, includeOrdinal, seasonType);
	}

	protected getOutcomeSuffix(numPeriods: number, seasonType: string) {
		return this.americanFootballUtils.getOutcomeSuffix(numPeriods, seasonType);
	}

	protected formatPeriodTime(periodTime: number) {
		return this.americanFootballUtils.formatPeriodTime(periodTime);
	}

	protected generateRecord(teamSummary: any) {
		return teamSummary.stats.wins + "-" + teamSummary.stats.losses + "-" + teamSummary.stats.ties;
	}

}
